import {
  AuthenticationDetails,
  CognitoUserPool,
  CognitoUser,
} from 'amazon-cognito-identity-js';
const { INFERNO_APP_USER_POOL_ID, INFERNO_APP_COGNITO_CLIENT_ID } = process.env;

/*
 * Authenticate a user with Cognito
 *
 * @param {Object} userData - The user's credentials for logging
 * @returns {String} token - The JWT returned from Cognito
*/
export default credentials => {
  return new Promise((resolve, reject) => {
    // Validation Checks //
    let validationError = null;
    if (!credentials || (!credentials.userName && !credentials.password)) {
      validationError = new Error('Missing userName or password');
      return reject(validationError);
    }
    if (!INFERNO_APP_USER_POOL_ID || !INFERNO_APP_COGNITO_CLIENT_ID) {
      validationError = new Error('Missing user_pool_id or cognito_client_id');
      return reject(validationError);
    }
    const { userName, password } = credentials;

    const authenticationData = {
      Username: userName,
      Password: password,
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);

    const poolData = {
      UserPoolId: INFERNO_APP_USER_POOL_ID,
      ClientId: INFERNO_APP_COGNITO_CLIENT_ID,
    };
    const userPool = new CognitoUserPool(poolData);

    const userData = {
      Username: userName,
      Pool: userPool,
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: result => {
        return resolve(result);
      },
      onFailure: err => {
        return reject(err);
      },
    });
  });
};



// WEBPACK FOOTER //
// ./src/cognito/authenticateUser.js